/**
 * Runtime configuration read from Vite environment variables.
 *
 * Only `VITE_`-prefixed variables reach the browser bundle. Never put backend
 * secrets (JWT secret, AWS keys, AI keys) in this file or in `.env` here --
 * everything in the frontend bundle is public.
 */

function requireEnv(value, name, fallback) {
  if (value && value.trim()) return value.trim();
  if (import.meta.env.PROD) {
    throw new Error(`Missing required environment variable ${name}`);
  }
  console.warn(`[config] ${name} is not set, falling back to "${fallback}"`);
  return fallback;
}

export const config = {
  apiBaseUrl: requireEnv(
    import.meta.env.VITE_API_BASE_URL,
    'VITE_API_BASE_URL',
    'http://localhost:8000/api/v1',
  ),
  appName: import.meta.env.VITE_APP_NAME ?? 'Join-Wonder',
  environment: import.meta.env.VITE_APP_ENV ?? 'development',
  isProduction: import.meta.env.PROD,
};
